var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7963 4.80188H13.5968C13.1553 4.80188 12.7969 5.16026 12.7969 5.60184C12.7969 6.04342 13.1553 6.40181 13.5968 6.40181H22.4652L17.5503 10.224L14.0256 7.98254L13.1681 9.33288L17.1679 11.8768C17.2975 11.96 17.4479 12.0016 17.5967 12.0016C17.7695 12.0016 17.9438 11.9456 18.0878 11.8336L23.9964 7.23697V17.6013H13.5968C13.1553 17.6013 12.7969 17.9597 12.7969 18.4013C12.7969 18.8428 13.1553 19.2012 13.5968 19.2012H24.7963C25.2379 19.2012 25.5963 18.8428 25.5963 18.4013V5.60184C25.5963 5.16026 25.2379 4.80188 24.7963 4.80188Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1098 0.185314C13.9274 0.0333207 13.6826 -0.0322764 13.4522 0.0157215L0.652771 2.41561C0.273588 2.48601 0 2.8156 0 3.20118V20.8004C0 21.1844 0.273588 21.5156 0.652771 21.586L13.4522 23.9858C13.5002 23.9954 13.5498 24.0002 13.5994 24.0002C13.785 24.0002 13.9658 23.9362 14.1098 23.8163C14.2938 23.6643 14.3994 23.4371 14.3994 23.2003V0.801286C14.3994 0.562897 14.2938 0.337307 14.1098 0.185314Z",
    fill: "#2196F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19513 17.5991C4.99043 17.5991 3.19531 15.4456 3.19531 12.7994C3.19531 10.1531 4.99043 7.99957 7.19513 7.99957C9.39983 7.99957 11.195 10.1531 11.195 12.7994C11.195 15.4456 9.39983 17.5991 7.19513 17.5991ZM7.19513 9.5995C5.87199 9.5995 4.79524 11.0346 4.79524 12.7994C4.79524 14.5641 5.87199 15.9992 7.19513 15.9992C8.51827 15.9992 9.59502 14.5641 9.59502 12.7994C9.59502 11.0346 8.51827 9.5995 7.19513 9.5995Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookIcon);
export default __webpack_public_path__ + "static/media/OutlookIcon.70c583b8b977bb1aa0556b4d3a95670b.svg";
export { ForwardRef as ReactComponent };